import { gql } from "@apollo/client";

export const GET_ALL_FASES = gql`
query GetAllFase {
    allFase{
            idFase,
            nombre,
            activo
      }
}`;